import React, { useState } from "react";
import { Badge, Box, Button, Card, Grid, Icon, Picture, Table, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import mixpanel from "mixpanel-browser";
import { useTranslation } from "react-i18next";
import lists from "~/lib/lists";
import NotMovingTableRow from "~/components/insightsWidgets/NotMovingTableRow";
import StyledIcon from "~/components/StyledIcon";
const StyledTable = styled(Table)`
  width: ${_ref => {
  let {
    theme
  } = _ref;
  return `calc(100% + ${10 * theme.typography.fontStep}rem)`;
}};
`;
const StyledTableHeader = styled(Table.Header)`
  border-bottom: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.borders.primary;
}};

  th {
    padding-bottom: 1em;
  }
`;
const NotMovingCard = _ref3 => {
  let {
    widget,
    ...rest
  } = _ref3;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const {
    items,
    bySource
  } = widget.data;
  const itemsPerPage = 3;
  const [page, setPage] = useState(1);
  const [selectedType, setSelectedType] = React.useState("all");
  const filteredItems = items.filter(item => selectedType === "all" || selectedType === item.source);
  const totalPageCount = Math.ceil(filteredItems.length / itemsPerPage);
  const paginatedItems = filteredItems.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  const handleNextPageClick = () => {
    setPage(prev => prev + 1);
    mixpanel.track(`Insights Not Moving – Next Page Click`, {
      from: page
    });
  };
  const handlePrevPageClick = () => {
    setPage(prev => prev - 1);
    mixpanel.track(`Insights Not Moving – Next Page Click`, {
      from: page
    });
  };
  const handleFilter = type => {
    setSelectedType(type);
    setPage(1);
    mixpanel.track(`Insights Not Moving – Filter Click`, {
      type
    });
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr auto",
    gap: 2,
    align: "end"
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 3
    }
  }, t("NotMovingCard.whatsNotMoving")), !!items.length && /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    s: {
      mb: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    fontSize: 3.4,
    s: {
      py: 1,
      pr: 1,
      pl: 3
    },
    color: selectedType === "all" ? "translucentPrimary" : "transparent",
    onClick: () => handleFilter("all"),
    outline: false
  }, "All", /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2,
      ml: 1
    },
    color: "translucent"
  }, Object.values(bySource).reduce((prev, curr) => prev + curr, 0))), Object.keys(bySource).map(key => /*#__PURE__*/React.createElement(Button, {
    key: key,
    fontSize: 3.4,
    s: {
      py: 1,
      pr: 1,
      pl: 3
    },
    color: selectedType === key ? "translucentPrimary" : "transparent",
    onClick: () => handleFilter(key),
    outline: false
  }, /*#__PURE__*/React.createElement(Picture, {
    width: "1rem",
    height: "1rem",
    display: "inline-block",
    border: "squared",
    s: {
      mb: -0.5,
      mr: 1
    },
    src: lists.common.apps.logos(theme)[key]
  }), lists.topics.footprintSources.names[key], /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2,
      ml: 2
    },
    color: "translucent"
  }, bySource[key]))))), filteredItems.length > itemsPerPage && /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    s: {
      mb: 5
    },
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handlePrevPageClick,
    color: "transparent",
    disabled: page === 1,
    s: {
      p: 1
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    display: "block",
    rotate: -90,
    src: "chevron"
  })), /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    color: "textSecondary"
  }, page, " of ", totalPageCount), /*#__PURE__*/React.createElement(Button, {
    onClick: handleNextPageClick,
    color: "transparent",
    disabled: totalPageCount <= 1 || page >= totalPageCount,
    s: {
      p: 1
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    display: "block",
    rotate: 90,
    src: "chevron"
  })))), items.length === 0 ? /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "tick",
    color: "translucentSuccess"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "Everything's on the move")) : /*#__PURE__*/React.createElement(StyledTable, {
    size: "m",
    fontSize: 3.2,
    tableProps: {
      style: {
        minWidth: "1000px"
      }
    },
    s: {
      mx: -5,
      mb: -5
    }
  }, /*#__PURE__*/React.createElement(StyledTableHeader, null, /*#__PURE__*/React.createElement(Table.Tr, null, /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }), /*#__PURE__*/React.createElement(Table.Th, {
    width: "180px"
  }, t("NotMovingCard.topic")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "100px"
  }, t("NotMovingCard.item")), /*#__PURE__*/React.createElement(Table.Th, null, t("NotMovingCard.description")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "100px"
  }, t("NotMovingCard.age")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "100px"
  }, t("NotMovingCard.owner")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "60px",
    center: true
  }, t("NotMovingCard.source")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "30px"
  }), /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }))), /*#__PURE__*/React.createElement(Table.Body, null, paginatedItems.map(item => /*#__PURE__*/React.createElement(NotMovingTableRow, {
    key: item.id,
    item: item
  })))));
};
export default NotMovingCard;